var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyseData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.83 5C11.2777 5 10.83 5.44772 10.83 6V19H14.16V6C14.16 5.44771 13.7123 5 13.16 5H11.83ZM16.16 19H18.5C19.0523 19 19.5 18.5523 19.5 18V10C19.5 9.44772 19.0523 9 18.5 9H16.16V19ZM16.16 7V6C16.16 4.34315 14.8169 3 13.16 3H11.83C10.1732 3 8.83 4.34315 8.83 6V11H6.5C4.84314 11 3.5 12.3431 3.5 14V18C3.5 19.6569 4.84315 21 6.5 21H18.5C20.1569 21 21.5 19.6569 21.5 18V10C21.5 8.34315 20.1569 7 18.5 7H16.16ZM8.83 13H6.5C5.94771 13 5.5 13.4477 5.5 14V18C5.5 18.5523 5.94772 19 6.5 19H8.83V13Z",
    fill: "url(#paint0_linear_3914_22727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3914_22727",
    x1: 12.5,
    y1: 3,
    x2: 12.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyseData);
export default __webpack_public_path__ + "static/media/AnalyseData.08ea008cdd1f5acbc074f69e5c32aee7.svg";
export { ForwardRef as ReactComponent };